import 'react-app-polyfill/ie11';
import { isIE } from 'react-device-detect';
import config from 'shared/config';

if (!isIE && config) {
  import('./appManager').then((module) => module.default());
} else {
  import('./polyfills').then(() => {
    import(
      'scenes/unsupportedBrowsers/components/FullPage/UnsupportedBrowserFullPage'
    ).then((module) => {
      module.default();
    });
  });
}
